import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-services12',
  templateUrl: './section-services12.component.html',
  styleUrls: ['./section-services12.component.css']
})
export class SectionServices12Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
